import type { UnknownObject } from '~/shared/interfaces'

export const camelize = (str: string): string => {
  return str.replace(/^([A-Z])|[\s-_]+(\w)/g, function (_, start, next) {
    if (next) {
      return next.toUpperCase()
    }
    return start.toLowerCase()
  })
}

export function fillOwnProperties(
  target: object,
  source: UnknownObject,
  ignoreProps: string[] = []
): void {
  const ownProps = new Set(
    Object.getOwnPropertyNames(target).filter(prop => !ignoreProps.includes(prop))
  )

  for (const [key, value] of Object.entries(source)) {
    const prop = ownProps.has(key) ? key : camelize(key)

    if (ownProps.has(prop)) {
      Reflect.set(target, prop, value)
    }
  }
}
